// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"99e3a3fa","105":"2595c56b"}[chunkId] + ".chunk.css";
};